export default "__VITE_ASSET__CSv3Gr2p__"